import {
  ANDROID_APP_DETAILS_REQUEST,
  ANDROID_APP_BATCH_DETAILS_REQUEST,
  ANDROID_APP_RECOMMEND_REQUEST,
  ANDROID_APP_STE_SHOW_QRCODE,
  ANDROID_APP_GROUP_REQUEST,
  ANDROID_APP_GIFT_REQUEST,
  ANDROID_APP_GIFT_RECEIVE_REQUEST,
} from '../constants/adetail';

export const getAAppDetails = param => ({
  type: ANDROID_APP_DETAILS_REQUEST,
  ...param,
});

export const getAAppBatchDetails = param => ({
  type: ANDROID_APP_BATCH_DETAILS_REQUEST,
  ...param,
});

export const geAAppRecommend = param => ({
  type: ANDROID_APP_RECOMMEND_REQUEST,
  ...param,
});

export const showAAppQRCode = visible => ({
  type: ANDROID_APP_STE_SHOW_QRCODE,
  visible,
});

export const getAAppGroup = param => ({
  type: ANDROID_APP_GROUP_REQUEST,
  ...param,
});

export const getAAppGift = param => ({
  type: ANDROID_APP_GIFT_REQUEST,
  ...param,
});

export const appAGiftReceive = param => ({
  type: ANDROID_APP_GIFT_RECEIVE_REQUEST,
  ...param,
});
